import { render, staticRenderFns } from "./mBadge.vue?vue&type=template&id=478b6182&scoped=true&"
import script from "./mBadge.vue?vue&type=script&lang=js&"
export * from "./mBadge.vue?vue&type=script&lang=js&"
import style0 from "./mBadge.vue?vue&type=style&index=0&id=478b6182&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478b6182",
  null
  
)

export default component.exports